import React from 'react';
import PlayerSelect from './PlayerSelect';
import { OPERATOR_OPTIONS, PLAYER_STATUS_OPTIONS, TACTICAL_UTILITY_OPTIONS, WEAPON_ROLE_OPTIONS } from './constants';

const headerLabels = {
  HP: ['Slot', 'Player', 'Status', 'Primary Role', 'Secondary Role', 'Operator', 'Tactical Utility 1', 'Tactical Utility 2'],
  SND: ['Slot', 'Player', 'Status', 'Primary Role', 'Secondary Role', 'Tactical Utility 1', 'Tactical Utility 2', 'Tactical Utility 3'],
  CTL: ['Slot', 'Player', 'Status', 'Primary Role', 'Secondary Role', 'Operator', 'Tactical Utility 1', 'Tactical Utility 2'],
};

const rowTemplate = {
  HP: '0.55fr 1.4fr 0.9fr 1fr 1fr 1fr 1fr 1fr',
  SND: '0.55fr 1.4fr 0.9fr 1fr 1fr 1fr 1fr 1fr',
  CTL: '0.55fr 1.4fr 0.9fr 1fr 1fr 1fr 1fr 1fr',
};

const AssignmentsTable = ({
  mode,
  rows = [],
  activePlayers = [],
  playerImages = {},
  onChange,
}) => {
  const renderRoleSelect = (row, rowIndex, field) => (
    <select
      className="player-roles-control"
      value={row[field] || ''}
      onChange={(e) => onChange(rowIndex, field, e.target.value)}
    >
      <option value="">Select role</option>
      {WEAPON_ROLE_OPTIONS.map((role) => (
        <option key={role.value} value={role.value}>{role.label}</option>
      ))}
    </select>
  );

  const renderUtilitySelect = (row, rowIndex, field) => (
    <select
      className="player-roles-control"
      value={row[field] || ''}
      onChange={(e) => onChange(rowIndex, field, e.target.value)}
    >
      <option value="">Select utility</option>
      {TACTICAL_UTILITY_OPTIONS.map((utility) => (
        <option key={utility} value={utility}>{utility}</option>
      ))}
    </select>
  );

  return (
    <div className="player-roles-table-wrap">
      <div className="player-roles-table-shell" style={{ minWidth: mode === 'SND' ? '1080px' : '960px' }}>
        <div
          className="player-roles-row header"
          style={{ gridTemplateColumns: rowTemplate[mode] }}
        >
          {headerLabels[mode].map((label) => <span key={label}>{label}</span>)}
        </div>

        {rows.map((row, rowIndex) => (
          <div
            key={`${mode}-${row.player || 'row'}-${rowIndex}`}
            className={`player-roles-row data ${(row.status || 'STARTER').toLowerCase()}`}
            style={{ gridTemplateColumns: rowTemplate[mode] }}
          >
            <div className="player-roles-slot-cell">
              <span className={`player-roles-slot-pill ${(row.status || 'STARTER').toLowerCase()}`}>
                S{rowIndex + 1}
              </span>
            </div>
            <div>
              <PlayerSelect
                value={row.player}
                options={activePlayers}
                onChange={(value) => onChange(rowIndex, 'player', value)}
                playerImages={playerImages}
              />
              {row.player ? (
                <span className={`player-roles-row-badge ${(row.status || 'STARTER').toLowerCase()}`}>
                  {(row.status || 'STARTER') === 'SUB' ? 'Sub' : 'Starting 5'}
                </span>
              ) : null}
            </div>
            <select
              className="player-roles-control"
              value={row.status || 'STARTER'}
              onChange={(e) => onChange(rowIndex, 'status', e.target.value)}
            >
              {PLAYER_STATUS_OPTIONS.map((status) => (
                <option key={status.value} value={status.value}>{status.label}</option>
              ))}
            </select>
            {renderRoleSelect(row, rowIndex, 'primaryRole')}
            {renderRoleSelect(row, rowIndex, 'secondaryRole')}

            {mode === 'SND' ? (
              <>
                {renderUtilitySelect(row, rowIndex, 'tacticalOne')}
                {renderUtilitySelect(row, rowIndex, 'tacticalTwo')}
                {renderUtilitySelect(row, rowIndex, 'tacticalThree')}
              </>
            ) : (
              <>
                <select
                  className="player-roles-control"
                  value={row.operator || ''}
                  onChange={(e) => onChange(rowIndex, 'operator', e.target.value)}
                >
                  <option value="">Select operator</option>
                  {OPERATOR_OPTIONS.map((operator) => (
                    <option key={operator} value={operator}>{operator}</option>
                  ))}
                </select>
                {renderUtilitySelect(row, rowIndex, 'tacticalOne')}
                {renderUtilitySelect(row, rowIndex, 'tacticalTwo')}
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AssignmentsTable;
